if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"app": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-extensions_default_src_utils_color-7f062f0":1,"extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-extensions_default_src_utils_color-7f062f1":1,"extensions_measurement-tracking_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTag-2159fb":1,"extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-extensions_default_src_utils_color-7f062f2":1,"extensions_cornerstone-dicom-seg_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTa-21e288":1,"extensions_cornerstone-dicom-pmap_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomT-5177de":1,"extensions_cornerstone-dynamic-volume_src_index_ts-extensions_default_src_DicomTagBrowser_Dic-015d6e":1,"extensions_dicom-microscopy_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTagBrow-ea741e":1,"extensions_tmtv_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTagBrowser_css-exte-0947ba":1,"extensions_test-extension_src_index_tsx-extensions_default_src_DicomTagBrowser_DicomTagBrowse-9c49f0":1,"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx":1,"extensions_dicom-microscopy_src_DicomMicroscopyViewport_tsx":1,"extensions_dicom-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx":1,"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx-extensions_defaul-234efa":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

__webpack_require__.F.miniCss = (chunkId) => {
	if((!__webpack_require__.o(installedCssChunks, chunkId) || installedCssChunks[chunkId] === undefined) && /^(extensions_(cornerstone(\-d(icom\-(pmap_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomT\-5177de|rt_src_viewports_OHIFCornerstoneRTViewport_tsx\-extensions_defaul\-234efa|seg_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomTa\-21e288)|ynamic\-volume_src_index_ts\-extensions_default_src_DicomTagBrowser_Dic\-015d6e)|_src_Viewport_OHIFCornerstoneViewport_tsx)|d(efault_src_DicomTagBrowser_DicomTagBrowser_css\-extensions_default_src_utils_color\-7f062f[012]|icom\-(microscopy_src_(DicomMicroscopyViewport_tsx|index_tsx\-extensions_default_src_DicomTagBrowser_DicomTagBrow\-ea741e)|pdf_src_viewports_OHIFCornerstonePdfViewport_tsx))|measurement\-tracking_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomTag\-2159fb|test\-extension_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomTagBrowse\-9c49f0|tmtv_src_index_tsx\-extensions_default_src_DicomTagBrowser_DicomTagBrowser_css\-exte\-0947ba)|app)$/.test(chunkId)) {
		installedCssChunks[chunkId] = null;
		var link = document.createElement('link');

		if (__webpack_require__.nc) {
			link.setAttribute("nonce", __webpack_require__.nc);
		}
		link.rel = "prefetch";
		link.as = "style";
		link.href = __webpack_require__.p + __webpack_require__.miniCssF(chunkId);
		document.head.appendChild(link);
	}
};

// no preloaded